import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type ComboPreviewType } from '@/defs/combo'
import { COLOR_ID_LABELS } from '@/defs/mtg'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'

type Props = {
  combo: ComboPreviewType
}

export const StatComboColorId = ({ combo }: Props) => {
  const { icon, label } = COLOR_ID_LABELS[combo.colorId]

  const popover = (
    <>
      <h2>
        <IconWithLabel iconBefore='mtg-wubrg'>Color Identity</IconWithLabel>
      </h2>
      <p>
        This combo requires a color identity of at least {label} (
        <Icon name={icon} />
        ).
      </p>
    </>
  )

  return (
    <StatCommonBox label={label} popover={popover}>
      <StatCommonFigure>
        <Icon name={icon} />
      </StatCommonFigure>
    </StatCommonBox>
  )
}
